// extracted by mini-css-extract-plugin
export default {"modalBox":"Login_modalBox__OhijY","ghButton":"Login_ghButton__LIDPE","ghIcon":"Login_ghIcon__zPoQI"};